import axios from 'axios'
import localforage from 'localforage'
import router from '../router'

const api = axios

api.defaults.baseURL = process.env.VUE_APP_API
api.defaults.headers.common.Accept = 'application/json'
api.defaults.headers.common['Content-Type'] = 'application/json'
api.defaults.headers.post['Content-Type'] = 'multipart/form-data'

api.interceptors.request.use(
    async config => {
        const deviceInfo = await localforage.getItem('deviceInfo')
        const token = await localforage.getItem('authToken')
        if (token) {
            config.headers.common.Authorization = `Bearer ${token}`
        }
        if (deviceInfo) {
            config.headers.common.deviceInfo = deviceInfo
        }
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

api.interceptors.response.use(
    async response => {
        if (response.status === 200 || response.status === 201) {
            // refresh token
            if (
                response.data.access_token &&
                response.data.access_token.token
            ) {
                await localforage.setItem(
                    'authToken',
                    response.data.access_token.token
                )
            }

            return Promise.resolve(response)
        } else {
            return Promise.reject(response)
        }
    },
    error => {
        if (error.response && error.response.status) {
            switch (error.response.status) {
            case 403:
                router.push({ name: 'logout', params: { code: 403 } })
                break
            case 404:
                router.push({ name: 'error404' })
                break
            }
        }
        return Promise.reject(error)
    }
)

export default api
